import { File, FileGroup, TypedFiles } from '../../../../types/catalog';
import { Fragment, useState } from 'react';

const FileWrapper = ({ file }: { file: File | TypedFiles }) => {
    if ((file as TypedFiles).type) {
        const { type, list } = file as TypedFiles;
        return (
            <Fragment>
                <div className="product-documents__label">{type}</div>
                {list.map(({ url, name }, idx) => (
                    <a
                        key={idx}
                        href={url}
                        className="product-documents-item"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <i className="fas fa-download" />
                        <div className="product-documents-item__title">{name}</div>
                    </a>
                ))}
            </Fragment>
        );
    } else {
        const { url, name } = file as File;
        return (
            <a href={url} className="product-documents-item" target="_blank" rel="noreferrer">
                <i className="far fa-file-pdf" />
                <div className="product-documents-item__title">{name}</div>
            </a>
        );
    }
};

function FileAccordion({ fileGroup }: { fileGroup: FileGroup }) {
    const [isOpen, setIsOpen] = useState(true);
    return (
        <div className={'product-documents ui-accordion' + (isOpen ? ' ui-accordion--active' : '')}>
            <div className="product-documents__title ui-accordion__head" onClick={() => setIsOpen(!isOpen)}>
                {fileGroup.name}
            </div>
            <div className="ui-accordion__body">
                <div className="product-documents__items">
                    {fileGroup.files.map((f, idx) => (
                        <FileWrapper file={f} key={idx} />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default FileAccordion;
